import { UuidT } from "../flatbuffers/generated/front-end/uuid";
import { U128T } from "../flatbuffers/generated/u128/u128";

export const ZERO_UUID_STRING = "00000000-0000-0000-0000-000000000000";

export const EMPTY_UUID = new UuidT(new U128T(BigInt(0), BigInt(0)));

export function uuidToString(uuid: UuidT | string | null): string {
  // Handle plain string UUIDs (from replay files / legacy data)
  if (typeof uuid === "string") return uuid || ZERO_UUID_STRING;
  if (!uuid?.value) return ZERO_UUID_STRING;

  const high = BigInt(uuid.value.upper);
  const low = BigInt(uuid.value.lower);

  const hex = `${high.toString(16).padStart(16, "0")}${low
    .toString(16)
    .padStart(16, "0")}`;

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function stringToUuidT(uuid: string): UuidT {
  if (!uuid) return EMPTY_UUID;
  const hex = uuid.replace(/-/g, "");
  if (hex.length < 32) return EMPTY_UUID;
  const upper = BigInt(`0x${hex.slice(0, 16)}`);
  const lower = BigInt(`0x${hex.slice(16, 32)}`);
  return new UuidT(new U128T(upper, lower));
}

export function uuidsEqual(a: UuidT | null, b: UuidT | null): boolean {
  if (a === b) return true;
  if (!a?.value || !b?.value) return !a?.value && !b?.value;
  return a.value.upper === b.value.upper && a.value.lower === b.value.lower;
}
